import { render, staticRenderFns } from "./surface_post_comments.vue?vue&type=template&id=516cf0c4&scoped=true&"
import script from "./surface_post_comments.vue?vue&type=script&lang=ts&"
export * from "./surface_post_comments.vue?vue&type=script&lang=ts&"
import style0 from "./surface_post_comments.vue?vue&type=style&index=0&id=516cf0c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516cf0c4",
  null
  
)

export default component.exports